'use client';

import { Suspense, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { generateKeycloakRegistrationUrl } from '@/utils/keycloakUrlUtils';
import { getSourcePath } from '@/rewrites';

const RegistrationRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    const redirectToRegistration = async () => {
      const registrationUrl = await generateKeycloakRegistrationUrl(getSourcePath('/search'));
      router.replace(registrationUrl);
    };

    redirectToRegistration();
  }, [router]);

  return <></>;
};

const SuspendedRegistrationRedirect = () => (
  <Suspense>
    <RegistrationRedirect />
  </Suspense>
);

export default SuspendedRegistrationRedirect;
